import miradorSharePlugin from './miradorSharePlugin';
import miradorShareDialogPlugin from './MiradorShareDialog';

export { miradorSharePlugin, miradorShareDialogPlugin };

export default [miradorSharePlugin, miradorShareDialogPlugin];
